import React from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../../../shadcn/ui/dialog";

const DeleteUserModal = ({ isOpen, onClose, userToDelete, deleteUserLoading, onConfirm }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto bg-white rounded-lg border border-gray-200 p-0">
        <div className="p-6">
          <div className="mb-6">
            <DialogTitle className="text-xl font-semibold text-gray-900 mb-2">Delete User</DialogTitle>
            <p className="text-sm text-gray-500">This action cannot be undone</p>
          </div>

          <div className="space-y-6 max-h-[60vh] overflow-y-auto">
            {userToDelete && (
              <div className="p-3 bg-gray-50 rounded-md">
                <p className="font-medium text-gray-900">
                  {userToDelete.firstName} {userToDelete.lastName}
                </p>
                <p className="text-sm text-gray-500">{userToDelete.emailAddress}</p>
                <p className="mt-1 text-xs text-gray-500">
                  Role: {userToDelete.organizationRole?.name || "No role assigned"}
                </p>
                <p className="text-xs text-gray-500">Status: {userToDelete.status}</p>
              </div>
            )}

            <div className="p-4 bg-red-50 rounded-md border border-red-200">
              <p className="mb-2 text-sm font-medium text-red-800">⚠️ Warning: This action cannot be undone</p>
              <p className="text-sm text-red-700">
                Are you sure you want to delete this user? This will permanently remove the user from the system and all
                associated data.
              </p>
              <p className="mt-2 text-xs text-red-600">
                Note: Only inactive users can be deleted. Active users must be deactivated first.
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-2 mt-6">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 flex items-center justify-center"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={deleteUserLoading}
            className="flex-1 px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          >
            {deleteUserLoading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Deleting...
              </>
            ) : (
              "Delete User"
            )}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteUserModal;
